export const environment = {
  production: false,
  environment_name: 'Staging',
  api_root: 'https://test.app.globalpeoplestrategist.com/',
  cache_timeout: 1000 * 60 * 60,   /* Remove all local caches after one hour */
  cors_proxy: 'https://gps-cors-proxy-f982a2f8d064.herokuapp.com/',
  mixpanel_token: '331d348cd117d119c15c20b4c5212280',
  currency_token: 'b0ea79297dab406aadb9734878bf7215',
  chargebee_site: 'globalpeoplestrategist-test'
};
